module.exports = "/assets/dist/images/carsaver_logo.png?190fc8bb59dd09d4a36c8b4347fbcbf0";